export const PostThreadController = {
    index(): void {},
    store(): void {},
};
